import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

function HomeTools() {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const axiosPrivate = useAxiosPrivate();
  const [searchParams] = useSearchParams();

  const subcatId = searchParams.get("subcategoryId");

  const [tools, setTools] = useState([]);

  useEffect(() => {
    if (!subcatId) return;
    const loadTools = async () => {
      try {
        const res = await axiosPrivate.get(`/ToolPassports/SelectOptionsBySubcategory/${subcatId}`);
        if (typeof res.data === "string" && res.data === "No records") {
          setTools([]);
        } else {
          setTools(res.data);
        }
      } catch (err) {
        enqueueSnackbar("Cannot load tools", { variant: "error" });
      }
    };
    loadTools();
  }, [subcatId, axiosPrivate, enqueueSnackbar]);

  // optionally open a modal or route to details 
  const handleToolClick = (toolId) => {
    // e.g. navigate to a details page or open a modal
    window.alert(`Open tool #${toolId} details or passport?`);
  };

  return (
    <div style={{ padding: "2rem" }}>
      <h2>Subcategory ID: {subcatId}</h2>
      <h3>{t("chooseTool")}</h3>
      <div className="panelContainer">
        {tools.length === 0 ? (
          <div>{t("noTools")}</div>
        ) : (
          tools.map((tool) => (
            <div
              key={tool.value}
              className="categoryBox"
              style={{ textAlign: "center" }}
              onClick={() => handleToolClick(tool.value)}
            >
              {/* (If you want an actual image or logo, you'd fetch more fields 
                  from a different endpoint—this one only returns { value, label }.) */}
              <div style={{ fontWeight: "bold" }}>{tool.label}</div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default HomeTools;
